import PropTypes from 'prop-types'
import styled, { keyframes, css } from 'styled-components'

import { PB97T, PB90T } from '../../colors'
import { getMargin, marginPropTypes } from '../../utils'

const baseColor = PB90T
const highlightColor = PB97T
const shimmer = keyframes`
  100% {
    transform: translateX(100%);
  }
`
const getAnimation = ({ isAnimated, duration }) => {
  if (!isAnimated) {
    return null
  }

  return css`
    animation: ${shimmer} ${duration}s ease-in-out infinite;
    background-image: linear-gradient(
      90deg,
      ${baseColor} 0%,
      ${highlightColor} 50%,
      ${baseColor} 100%
    );
  `
}
const Box = styled.span`
  display: ${({ display }) => display};
  position: relative;
  overflow: hidden;
  background-color: ${baseColor};
  border-radius: ${props => (props.circle ? '50%' : '4px')};
  height: ${props => (props.circle ? `calc(2 * ${props.radius}) ` : props.height)};
  width: ${props => (props.circle ? `calc(2 * ${props.radius}) ` : props.width)};
  ${getMargin};

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateX(-100%);
    ${getAnimation};
  }
`
/**
 * The Skeleton can be used to indicate that an element is loading.
 * It can be used as a building block to create skeletons for larger
 * sections of a page like menus, bodies, feeds, sidebars, etc.
 */
const Skeleton = ({
  display = 'inline-block',
  width = '100%',
  height = '15px',
  circle = false,
  radius = '25px',
  duration = 1.5,
  isAnimated = true,
  ...rest
}) => {
  return (
    <Box
      display={display}
      width={width}
      height={height}
      circle={circle}
      radius={radius}
      duration={duration}
      isAnimated={isAnimated}
      {...rest}
    />
  )
}

Skeleton.propTypes = {
  ...marginPropTypes,
  display: PropTypes.oneOf(['inline-block', 'block']),
  /** Sets the width of the skeleton. */
  width: PropTypes.string,
  /** Sets the height of the skeleton. */
  height: PropTypes.string,
  /** Whether the skeleton is a circle or not. */
  circle: PropTypes.bool,
  /** Sets the radius of the circle if circle prop is true. */
  radius: PropTypes.string,
  /** Sets the duration of the highlight animation. */
  duration: PropTypes.number,
  /** Whether the skeleton has an animation effect. */
  isAnimated: PropTypes.bool
}

export { Skeleton }
